// extracted by mini-css-extract-plugin
export default {"pageContainer":"pageNotFound_pageContainer__U9Zji","title":"pageNotFound_title__90KKU","content":"pageNotFound_content__Dt26q","actionBox":"pageNotFound_actionBox__Df1BB"};